var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.955,
    height: 20.252,
    viewBox: "0 0 13.955 20.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "location",
    d: "M5091.427,3332.692l-5.632-9.164a8.392,8.392,0,0,1-1.343-4.119,7.105,7.105,0,0,1,6.975-6.969,6.98,6.98,0,0,1,5.747,10.937Zm0-19.721a6.576,6.576,0,0,0-6.445,6.459,8.075,8.075,0,0,0,1.251,3.8l5.2,8.449,5.3-8.592a6.449,6.449,0,0,0-5.3-10.117Zm0,8.954a2.886,2.886,0,1,1,2.89-2.884A2.886,2.886,0,0,1,5091.422,3321.925Zm0-5.241a2.355,2.355,0,1,0,2.36,2.357A2.357,2.357,0,0,0,5091.422,3316.684Z",
    transform: "translate(-5084.449 -3312.44)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.758fcb4639a07287fbb9c669a58c100b.svg";
export { ForwardRef as ReactComponent };